/* FFA Retail — theme.js */

(function () {
  'use strict';

  // ─── Sticky header blur on scroll ───────────────────────────────────────────
  var header = document.getElementById('site-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('scrolled', window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ─── Mobile menu ────────────────────────────────────────────────────────────
  var menuToggle  = document.getElementById('menu-toggle');
  var drawerClose = document.getElementById('drawer-close');
  var drawerOverlay = document.getElementById('drawer-overlay');
  var navDrawer   = document.getElementById('nav-drawer');

  function openDrawer() {
    if (!navDrawer) return;
    navDrawer.classList.add('is-open');
    navDrawer.setAttribute('aria-modal', 'true');
    document.body.style.overflow = 'hidden';
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
    if (drawerClose) drawerClose.focus();
  }

  function closeDrawer() {
    if (!navDrawer) return;
    navDrawer.classList.remove('is-open');
    navDrawer.setAttribute('aria-modal', 'false');
    document.body.style.overflow = '';
    if (menuToggle) {
      menuToggle.setAttribute('aria-expanded', 'false');
      menuToggle.focus();
    }
  }

  if (menuToggle)    menuToggle.addEventListener('click', openDrawer);
  if (drawerClose)   drawerClose.addEventListener('click', closeDrawer);
  if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && navDrawer && navDrawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  // ─── Search toggle ────────────────────────────────────────────────────────
  var searchToggle = document.getElementById('search-toggle');
  var searchClose  = document.getElementById('search-close');
  var siteSearch   = document.getElementById('site-search');

  function openSearch() {
    if (!siteSearch) return;
    siteSearch.hidden = false;
    if (searchToggle) searchToggle.setAttribute('aria-expanded', 'true');
    var input = siteSearch.querySelector('input');
    if (input) input.focus();
  }

  function closeSearch() {
    if (!siteSearch) return;
    siteSearch.hidden = true;
    if (searchToggle) {
      searchToggle.setAttribute('aria-expanded', 'false');
      searchToggle.focus();
    }
  }

  if (searchToggle) searchToggle.addEventListener('click', openSearch);
  if (searchClose)  searchClose.addEventListener('click', closeSearch);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && siteSearch && !siteSearch.hidden) closeSearch();
  });

  // ─── Add to cart (AJAX) ──────────────────────────────────────────────────
  var productForms = document.querySelectorAll('#product-form, form[action="/cart/add"]');

  productForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (!btn || btn.disabled) return;

      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = 'Adding...';

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          btn.textContent = 'Added!';
          showCartNotification();
          updateCartCount();
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2000);
        })
        .catch(function () {
          btn.textContent = originalText;
          btn.disabled = false;
          alert('Something went wrong. Please try again.');
        });
    });
  });

  function showCartNotification() {
    var notif = document.getElementById('cart-notification');
    if (!notif) return;
    notif.hidden = false;
    setTimeout(function () { notif.hidden = true; }, 3500);
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var countEl = document.querySelector('.cart-count');
        if (!countEl) {
          if (cart.item_count > 0) {
            var cartLink = document.querySelector('.site-header__cart');
            if (cartLink) {
              var span = document.createElement('span');
              span.className = 'cart-count';
              span.setAttribute('aria-hidden', 'true');
              span.textContent = cart.item_count;
              cartLink.appendChild(span);
            }
          }
        } else {
          countEl.textContent = cart.item_count;
          countEl.hidden = cart.item_count === 0;
        }
        var cartLink = document.querySelector('.site-header__cart');
        if (cartLink) {
          cartLink.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items');
        }
      });
  }

  // ─── Cart quantity controls ───────────────────────────────────────────────
  document.querySelectorAll('.qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var action   = this.dataset.action;
      var key      = this.dataset.key;
      var valEl    = this.parentElement.querySelector('.qty-value');
      var current  = parseInt(valEl ? valEl.textContent : '1', 10);
      var newQty   = action === 'increase' ? current + 1 : Math.max(0, current - 1);

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: key, quantity: newQty })
      })
        .then(function (res) { return res.json(); })
        .then(function () { window.location.reload(); });
    });
  });

  // ─── Active nav link highlight ────────────────────────────────────────────
  var currentPath = window.location.pathname;
  document.querySelectorAll('.site-header__nav-link, .dropdown-menu__link').forEach(function (link) {
    if (link.getAttribute('href') === currentPath) {
      link.classList.add('active');
      link.setAttribute('aria-current', 'page');
    }
  });

})();
